import React from 'react';
import TeachersDay2025 from 'views/TeachersDay2025';

const SchoolProgrampage = () => {
  return <TeachersDay2025/>;
};

export default SchoolProgrampage;